import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import RecruitModuleTypes from '@/store/modules/middleGround/recruit/interface';

const recruitModule: Module<RecruitModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
       
    },
    mutations: {
        
    },
    actions: {
        pageActivityList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/pageActivityList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listProject(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/listProject", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listJoinCategory(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/listJoinCategory", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveActivity(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/saveActivity", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivity(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/getActivity", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityImage(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/listActivityImage", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteActivity(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/deleteActivity", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateActivityStatus(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/updateActivityStatus", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivity(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/listActivity", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageActivityApplyList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/pageActivityApplyList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivityApply(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/getActivityApply", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateActivityApplyAuditStatus(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/updateActivityApplyAuditStatus", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveJoinCategory(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/activity/saveJoinCategory", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        downloadExcelActivityApplyList(context, searchParams) {
          return new Promise((resolve, reject) => {
              tool.downloadExcel("/middle/activity/downloadExcelActivityApplyList", searchParams).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
        },
        
        
    },
};

export default recruitModule;